<template>
  <div>
    <VendorSearch ref="mdlVendorSearch" @submit="handleVendor_Submit"/>

    <template v-if="userData.ReceivingCount > 0">
      <kst-warning class="mb-4" :items="detailsWarning"/>
    </template>

    <kst-input load-on-focus field="PONumber" :data="userData" :catalog="Catalog"/>
    <kst-input field="Date" :data="userData" :catalog="Catalog"/>

    <kst-output control-off status-off
      field="VendorID" :data="userData" :catalog="Catalog"
    >
      <template #left>
        <kst-output addons floating-label
          field="VendorAlias" :data="userData" :catalog="Catalog"
        />
      </template>
      <template #default>
        <kst-input addons expanded floating-label
          field="Vendor"
          :disabled="userData.VendorID !== null || userData.ReceivingCount > 0"
          :data="userData"
          :catalog="Catalog"
        />
      </template>
      <template v-if="userData.ReceivingCount === 0" #right>
        <div class="control">
          <template v-if="userData.VendorID === null">
            <kst-tooltip search-mode hover-only :content="Catalog.Vendor.Label">
              <kst-button search-mode @click="handleSearch_Vendor"/>
            </kst-tooltip>
          </template>
          <template v-else>
            <kst-tooltip clear-mode hover-only :content="Catalog.Vendor.Label">
              <kst-button clear-mode @click="handleClear_Vendor"/>
            </kst-tooltip>
          </template>
        </div>
      </template>
    </kst-output>

    <kst-input field="VendorAddress" :data="userData" :catalog="Catalog"/>
    <kst-input field="WarehouseID" :data="userData" :catalog="Catalog"
      :options="warehouseOptions" @input="handleWarehouse"
    />
    <kst-input field="Comment" :data="userData" :catalog="Catalog"/>
    
    <kst-section class="mt-5" :title="sectionTitle">
      <kst-input field="DeliveryAddress" :data="userData" :catalog="Catalog"/>
      <kst-input field="DeliveryDate" :data="userData" :catalog="Catalog"/>
    </kst-section>
  </div>
</template>

<script>
import Catalog from "../PurchaseCatalog.js";
import Info from "../PurchaseInfo.js";
import Model from "../PurchaseModel.js";

import VendorSearch from "@/components/Vendor/Search/VendorSearch";

export default {
  components: {
    VendorSearch
  },
  props: {
    userData: Object,
    warehouseOptions: Object
  },
  data: () => ({
    Catalog: Catalog
  }),
  computed: {
    detailsWarning() {
      return [Info.Message.Edit_EditVendor];
    },
    sectionTitle() {
      return Info.Section.Delivery.Title;
    }
  },
  methods: {
    handleWarehouse() {
      Model.setDetailsByWarehouse(this.userData, this.warehouseOptions);
    },

    handleSearch_Vendor() {
      this.$refs.mdlVendorSearch.show();
    },
    handleClear_Vendor() {
      Model.clearDetailsByVendor(this.userData);
    },

    handleVendor_Submit(row) {
      Model.setDetailsByVendor(this.userData, row);
    }
  }
}
</script>